import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./App.css";
import "../src/Component/Modal/Modal.css";
import Home from "../src/View/Home/Index";
import Login from "./Athentication/Login";
import MainLayout from "./Layout/MainLayout";
import PrivateRouter from "./privateRouter/PrivateRouter";
import NotFound from "./NotFound/NotFound";
import CompanyType from "./Pages/type of company/CompanyType";
import Designation from "./Pages/Designation/Designation";
import Services from "./Pages/Services/Services";
import MultiStepForm from "./Pages/UserAdd/UserAdd";
import ViewTable from "./Pages/UserView/ViewTable";
import ProfileType from "./Pages/ProfileType/ProfileType";
import NonMember from "./Pages/NonMember/NonMember";

import MemberOwnProfile from "./View/Profile/MemberOwnProfile";
import NonMemberUpgraded from "./Pages/NonMember/NonMemberUpgraded";
import NonMemberUpgradeRequest from "./Pages/NonMember/NonMemberUpgradeRequest";
import UpgradedNonMember from "./Pages/NonMember/UpgradedNonMember";
import OfferCategory from "./Pages/OfferCategory/OfferCategory";
import Offers from "./Pages/Offers/Offers";
import ViewManageOffer from "./Pages/Offers/ViewManageOffer";
import PurchaseHistory from "./Pages/UserHistory/PurchaseHistory";
import RewardHistory from "./Pages/UserHistory/RewardHistory";
import PartnerPurchaseDetails from "./Pages/Offers/PartnerPurchaseDetails";
import Profile from "./Pages/AdminProfile/Profile";
import NonMemberEdit from "./Pages/NonMember/NonMemberEdit";
import MessageCategories from "./Pages/Message/Categories/MessageCategories";
import UserMessage from "./Pages/Message/Users/UserMessage";
import PromoCode from "./Pages/PromoCode/PromoCode";
import MemberBusinessList from "./Pages/BusinessList/MemberBusinessList";
import NonMemberBusinessList from "./Pages/BusinessList/NonMemberBusinessList";
import Keywords from "./Pages/Keywords/Keywords";
import Posts from "./Pages/Posts/Posts";
import Comments from "./Pages/Posts/Comments";
import EnquiryList from "./Pages/Posts/EnquiryList";
import SubscriptionPlans from "./Pages/Subscription/SubscriptionPlans";
import SponsorAd from "./Pages/SponsorAd/SponsorAd";
import NonMemberBusinessListEdit from "./Pages/NonMember/NonMemberBusinessListEdit";
import MemberBusinessListEdit from "./Pages/Member/MemberBusinessListEdit";
import PostEdit from "./Pages/Posts/PostEdit";
import SendMessageMembers from "./Pages/Message/SendMessageMembers";
import SendMessageNonMembers from "./Pages/Message/SendMessageNonMembers";
import SendMessageBLMUsers from "./Pages/Message/SendMessageBLMUsers";
import MemberBusinessListPending from "./Pages/BusinessList/MemberBusinessListPending";
import NonMemberBusinessListPending from "./Pages/BusinessList/NonMemberBusinessListPending";
import BLMListApproved from "./Pages/BusinessList/BLMListApproved";
import BLMListPending from "./Pages/BusinessList/BLMListPending";
import BLMListPaid from "./Pages/BusinessList/BLMListPaid";
import BLMListSuspended from "./Pages/BusinessList/BLMListSuspended";
import BLMListBasic from "./Pages/BusinessList/BLMListBasic";
import BLMListSilver from "./Pages/BusinessList/BLMListSilver";
import BLMListGold from "./Pages/BusinessList/BLMListGold";
import BLMSilverRequest from "./Pages/BusinessList/BLMSilverRequest";
import BLMGoldRequest from "./Pages/BusinessList/BLMGoldRequest";
import HomePageBackground from "./Pages/HomePageBackground/HomePageBackground";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<PrivateRouter />}>
            <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/type-of-company" element={<CompanyType />} />
              <Route path="/type-of-designation" element={<Designation />} />
              <Route path="/type-of-services" element={<Services />} />
              <Route path="/add-user-form" element={<MultiStepForm />} />
              <Route path="/view-user-data" element={<ViewTable />} />
              <Route path="/profile-type" element={<ProfileType />} />
              <Route path="/non-member" element={<NonMember />} />
              <Route path="/non-member-edit" element={<NonMemberEdit />} />
              <Route
                path="/non-member-upgrade-request-home"
                element={<NonMemberUpgradeRequest />}
              />
              <Route
                path="/non-member-request-upgradation"
                element={<NonMemberUpgraded />}
              />
              <Route
                path="/upgraded-non-member-home"
                element={<UpgradedNonMember />}
              />
              <Route path="/offer-category" element={<OfferCategory />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/manage-offers" element={<ViewManageOffer />} />
              <Route
                path="/message-categories"
                element={<MessageCategories />}
              />
              <Route path="/message-user" element={<UserMessage />} />
              <Route
                path="/partner-purchase-history/:id"
                element={<PartnerPurchaseDetails />}
              />
              {/* HISTORY */}
              <Route
                path="/purchase-history/:id"
                element={<PurchaseHistory />}
              />
              <Route path="/reward-history/:id" element={<RewardHistory />} />
              <Route path="/promo-code" element={<PromoCode />} />
              {/* Business List */}
              <Route path="/member-business-list" element={<MemberBusinessList />} />
              <Route path="/member-business-list-pending" element={<MemberBusinessListPending />} />
              <Route path="/non-member-business-list" element={<NonMemberBusinessList />} />
              <Route path="/non-member-business-list-pending" element={<NonMemberBusinessListPending />} />
              <Route path="/member-business-list-edit" element={<MemberBusinessListEdit />} />
              <Route path="/non-member-business-list-edit" element={<NonMemberBusinessListEdit />} />
              <Route path="/keywords" element={<Keywords />} />
              <Route path="/approved-blm-users" element={<BLMListApproved />} />
              <Route path="/pending-blm-users" element={<BLMListPending />} />
              <Route path="/paid-blm-users" element={<BLMListPaid />} />
              <Route path="/suspended-blm-users" element={<BLMListSuspended />} />

              <Route path="/basic-blm-users" element={<BLMListBasic />} />
              <Route path="/silver-blm-users" element={<BLMListSilver />} />
              <Route path="/gold-blm-users" element={<BLMListGold />} />
              {/* Plan Upgrade Request */}
              <Route path="/silver-requested-blm-users" element={<BLMSilverRequest />} />
              <Route path="/gold-requested-blm-users" element={<BLMGoldRequest />} />
              {/* Posts */}
              <Route path="/posts" element={<Posts />} />
              <Route path="/comments" element={<Comments />} />
              <Route path="/enquiry-list" element={<EnquiryList />} />
              <Route path="/edit-post" element={<PostEdit />} />
              {/* Subscription Plan */}
              <Route path="/subscription-plans" element={<SubscriptionPlans />} />
              {/* SponsorAd */}
              <Route path="/sponsor-ad" element={<SponsorAd />} />
              {/* Send message/update */}
              <Route path="/send-message-to-members" element={<SendMessageMembers />} />
              <Route path="/send-message-to-nonmembers" element={<SendMessageNonMembers />} />
              <Route path="/send-message-to-blm-members" element={<SendMessageBLMUsers />} />
              {/* Homepage Background */}
              <Route path="/homepage-background" element={<HomePageBackground />} />
            </Route>
          </Route>

          <Route path="/recently-added-user" element={<MemberOwnProfile />} />

          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
